<template v-if="this.isLogin"> 
    <div class="footer">
        <!-- <p id="ayat">A good name is worth more than silver or gold. To be respected is better than to be rich.</p> -->
        <p id="ayat">2025</p>
        <p id="copyright">SikuRaja V.2.28 © otnielpangkung - 2022</p>
    </div>  
</template>

<script>
import axios from "../API/axios"
import Swal from "sweetalert2";
export default {
name: "Footer",
data() {
    return {
        password:""
    }
},
created() {
  this.$store.dispatch('getLocalStorage')
},
methods: {
    
},
computed: {
  isLogin() {
    return this.$store.state.isLogin
  }
},
}
</script>

<style scoped>
.footer {
    display: flex;
    font-weight: 800;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
    padding: 5px 10px;
    top: 0;
    color: #eaeaea;
    /* background-color: rgb(244, 244, 244); */
    background-color:#6A80B9;   
}

p {
    margin-bottom: 0px!important;
    font-size: 11px;
    font-weight: 500;
}
#ayat {
}
#userImg {
    width: 24px;
    height: 24px;
}
button {
    border: none;
    background-color: transparent;
}
.rightSide{
    display: flex;
}

</style>